import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape({
  twoFaCode: yup
    .string()
    .required('Please enter the code')
    .min(6, 'Please enter the code')
    .max(6, 'Please enter the code')
    .matches(/^[0-9]*$/, 'Please enter the code'),
})
export const resolver = yupResolver(Schema)
